import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetUserGaDataActionType, TUserGaData } from './types';
import { IUserGaData } from '../../../types/analytics';

export const setUserGaData: (data: IUserGaData) => TUserGaData = actionGenerator<
  ESetUserGaDataActionType.Set,
  IUserGaData
>(ESetUserGaDataActionType.Set);
